import '../navbar.css'
import { useState } from 'react'
import { ReactComponent as Hamburger } from '../hamburger.svg'
import { ReactComponent as Brand } from '../logo.svg'
import { NavLink, useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';

const NavBarCustom = ({ loggedIn , onLogout }) => {
  const navigate = useNavigate();
  const [showNavbar, setShowNavbar] = useState(false);

  async function logOut() {
    await Auth.signOut();
    await onLogout();
    setShowNavbar(false);
    navigate('/signin');
  }

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  return (
    <nav className='navbar'>
      <div className="container">
        <div className="logo">
          <Brand />
        </div>

        <div className="menu-icon" onClick={handleShowNavbar}>
          <Hamburger />
        </div>

        <div className={`nav-elements ${showNavbar && 'active'}`}>
          <ul>
            <li><NavLink to="/">Home</NavLink></li>

            {!loggedIn ? (
              <li><NavLink to="/signin">Login</NavLink></li>
            ) : (
              <>
                <li><NavLink to="/protected">Quick Check</NavLink></li>
                <li><NavLink to="/protected2">Patients</NavLink></li>
                <li><NavLink to="/protected3">Biorhythm</NavLink></li>
                <li><NavLink to="/signin" onClick={logOut}>Logout</NavLink></li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBarCustom;